import { Cart, OperationLine, Stretches } from "../@types/Data";

const baseURL = "https://api.marketingpyme.com";
// const baseURL = "http://localhost:4000";
// Request Base
export const baseRequest = async<T>(route: string, config?: RequestInit): Promise<T> => {
    config = { credentials: 'include', ...(config || {}) };
    const requestResult = await fetch(`${baseURL}/api/${route}`, config);
    return requestResult.json();
};


export const getData = async (id: number) => {
    return await baseRequest<OperationLine[]>(`data?id=${id}`);
};

export const getOperationLine = async (id_operationLine: number) => {
    return await baseRequest<OperationLine>(`operationLine?id_op=${id_operationLine}`);
}

export const getTrayectoByID = async (id_operationLine: number, id_trayecto: number) => {
    return await baseRequest<Stretches>(`trayecto?id_operationLine=${id_operationLine}&id_trayecto=${id_trayecto}`);
}

export const getPaymentToken = async (signature: string, amount: number, customer_ext_id: string, additional_info: string,
    service_uuid: string, url_post: string, description: string, url_ok?: string, url_ko?: string) => {

    const body = JSON.stringify({
        signature: signature,
        amount: amount,
        operative: "AUTHORIZATION",
        customer_ext_id: customer_ext_id,
        additional: additional_info,
        service: service_uuid,
        secure: true,
        url_post: url_post,
        url_ok: url_ok,
        url_ko: url_ko,
        description: description,
        save_card: false
    });


    const request = await fetch(`${baseURL}/api/payment`, {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({body}),
        method: 'POST'
    });
    return request.json();

}

export const getPaymentPage = async(token: string) => {
    const request = await fetch(`${baseURL}/api/payment/process`, {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({token: token}),
        method: 'POST'
    });
    return request.text();
}

export const addToCart = async(stretchID: number, json: string, additionalInfo: string, uuid?: string) => {
    const request = await fetch(`${baseURL}/api/addToCart`, {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({stretchID: stretchID, json: json, additionalInfo: additionalInfo, uuid: uuid}),
        method: 'POST'
    });
    return request.json();
};

export const getCart = async(uuid: string) => {
    return await baseRequest<Cart[]>(`getCart?uuid=${uuid}`);
};

export const deleteItemFromCart = async(uuid: string, stretch_id: number, ticketNumber: string) => {
    const request = await fetch(`${baseURL}/api/deleteItem`, {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({stretchID: stretch_id, uuid: uuid, ticketNumber: ticketNumber}),
        method: 'POST'
    });
    return request.json();
}